import turnContainerToLink from './components/container-click';
import MicroModal from 'micromodal';
import collapsedContent from './components/collapsable-content';

turnContainerToLink();
collapsedContent();

function triggerIframeAction(action) {
    const video = document.querySelector('.modal-youtube-video .rll-youtube-player iframe');
    if (video && video.contentWindow) {
        video.contentWindow.postMessage('{"event":"command", "func":"'+action+'", "args":""}', '*');
    }
}

MicroModal.init({
    disableFocus: true,
    onShow: function (modal, element, event) {
        event.preventDefault();
        if(modal && modal?.classList?.contains('modal-youtube-video')) {
            const button = document.querySelector('.modal-youtube-video .rll-youtube-player').firstChild;
            if (typeof button !== 'undefined' && button !== null && !element.classList.contains('feedback-button')) {
                button.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    triggerIframeAction('playVideo');
                });
                button.click();
            }
        }
    },
    onClose: function (modal, element, event) {
        event.preventDefault();
        if(modal && modal?.classList?.contains('modal-youtube-video')) {
            triggerIframeAction('pauseVideo');
        }
    },
});
